import { render, staticRenderFns } from "./Genitores.vue?vue&type=template&id=2b65ed97&"
import script from "./Genitores.vue?vue&type=script&lang=js&"
export * from "./Genitores.vue?vue&type=script&lang=js&"
import style0 from "./Genitores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports